import { ReactComponent as CheckCircle } from 'assets/icons/check_circle.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import clsx from 'clsx';
import Button from 'components/Button/Button';

import type IEmptyTaskManagement from './interfaces/IEmptyTaskManagement';

import styles from './sass/EmptyTaskManagement.module.scss';

function EmptyTaskManagement({
  title, buttonTitle, buttonOnClick, disabledButton, className, checkIcon, hideButton = false,
}: IEmptyTaskManagement) {
  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.header}>
        {checkIcon ? <CheckCircle /> : <InfoIcon />}
        <p>{title}</p>
      </div>
      {buttonTitle && buttonOnClick && !hideButton ? (
        <Button
          className={styles.button}
          title={buttonTitle}
          onClick={buttonOnClick}
          disabled={disabledButton}
        />
      ) : null}
    </div>
  );
}

export default EmptyTaskManagement;
